export const ADMIN_AVAILABILITY_OPTIONS = [
  'Additional Options',
  'Available',
  'Unavailable',
  'Incomplete Information',
  'Sold by Others',
  'Sold by Vruddhi',
  'Not Responding',
  'Rejected',
  'Pending Verification',
];

const ADMIN_AVAILABILITY_NORMALIZATION = {
  'additional options': 'Additional Options',
  available: 'Available',
  unavailable: 'Unavailable',
  'incomplete information': 'Incomplete Information',
  'sold by others': 'Sold by Others',
  'sold by vruddhi': 'Sold by Vruddhi',
  'not responding': 'Not Responding',
  rejected: 'Rejected',
  'pending verification': 'Pending Verification',
};

export const normalizeAdminAvailability = (value, fallback = 'Available') => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();
  if (!normalized) return fallback;

  return ADMIN_AVAILABILITY_NORMALIZATION[normalized] || fallback;
};
